import React from 'react';

import { postEmbryoTransferInstructions } from 'kb-shared';
import { InstructionsModal, InstructionRow } from 'screens/MyJourney/details/InstructionsModal';

import instructionRenderer from '../instructionRenderer';

interface ShowProps {
  show: boolean;
  hide: () => void;
}

const POST_PROCEDURE_INSTRUCTIONS: InstructionRow[] =
  postEmbryoTransferInstructions.map(instructionRenderer);

export const PostEmbryoTransferInstructionsModal = ({ show, hide }: ShowProps) => {
  return (
    <InstructionsModal
      title="Post-procedure instructions"
      show={show}
      hide={hide}
      rows={POST_PROCEDURE_INSTRUCTIONS}
    />
  );
};
